import {makeAutoObservable} from "mobx"
import {api, catchApi} from "../../api"
import {
    CustomerProjectionDto,
    ReceiverDto,
    ScanDocumentDataAbeDto,
    ScanDocumentDataContractDto,
    ScanDocumentDataCertDto,
    ScanDocumentDataCocDto,
    ScanDocumentDataCor1Dto,
    ScanDocumentDataCor2Dto,
    ScanDocumentDataCoverLetterDto,
    ScanDocumentDataEnvelopeDto,
    ScanDocumentDataIdCardDto,
    ScanDocumentDataOtherDto,
    ScanDocumentDataSalaryStatementDto,
} from "../../api/sea";

type DataType = ScanDocumentDataAbeDto
    & ScanDocumentDataCertDto
    & ScanDocumentDataCocDto
    & ScanDocumentDataCor1Dto
    & ScanDocumentDataCor2Dto
    & ScanDocumentDataCoverLetterDto
    & ScanDocumentDataEnvelopeDto
    & ScanDocumentDataContractDto
    & ScanDocumentDataIdCardDto
    & ScanDocumentDataSalaryStatementDto
    & ScanDocumentDataOtherDto

class SeaDocumentDetailStore {
    get id(): string | undefined {
        return this._id;
    }

    set id(value: string | undefined) {
        this._id = value;
    }
    get pageCount(): number {
        return this._pageCount;
    }
    set pageCount(value: number) {
        this._pageCount = value;
    }
    get position(): number {
        return this._position;
    }
    set position(value: number) {
        this._position = value;
    }
    get firstDateOfRegistration(): string | undefined {
        return this._firstDateOfRegistration;
    }
    set firstDateOfRegistration(value: string | undefined) {
        this._firstDateOfRegistration = value;
    }
    get receiver(): ReceiverDto | undefined {
        return this._receiver;
    }
    set receiver(value: ReceiverDto | undefined) {
        this._receiver = value;
    }
    get licensePlate(): string | undefined {
        return this._licensePlate;
    }
    set licensePlate(value: string | undefined) {
        this._licensePlate = value;
    }
    get dateOfRegistration(): string | undefined {
        return this._dateOfRegistration;
    }
    set dateOfRegistration(value: string | undefined) {
        this._dateOfRegistration = value;
    }
    get dateOfDeRegistration(): string | undefined {
        return this._dateOfDeRegistration;
    }
    set dateOfDeRegistration(value: string | undefined) {
        this._dateOfDeRegistration = value;
    }
    get vin(): string | undefined {
        return this._vin;
    }
    set vin(value: string | undefined) {
        this._vin = value;
    }
    get documentNumber(): string | undefined {
        return this._documentNumber;
    }
    set documentNumber(value: string | undefined) {
        this._documentNumber = value;
    }
    get loading(): boolean {
        return this._loading;
    }
    set loading(value: boolean) {
        this._loading = value;
    }
    get auditVersion(): number {
        return this._auditVersion;
    }
    set auditVersion(value: number) {
        this._auditVersion = value;
    }
    get auditLastModifiedDate(): string | undefined {
        return this._auditLastModifiedDate;
    }
    set auditLastModifiedDate(value: string | undefined) {
        this._auditLastModifiedDate = value;
    }
    get auditLastModifiedBy(): string | undefined {
        return this._auditLastModifiedBy;
    }
    set auditLastModifiedBy(value: string | undefined) {
        this._auditLastModifiedBy = value;
    }
    get auditCreatedDate(): string | undefined {
        return this._auditCreatedDate;
    }
    set auditCreatedDate(value: string | undefined) {
        this._auditCreatedDate = value;
    }
    get auditCreatedBy(): string | undefined {
        return this._auditCreatedBy;
    }
    set auditCreatedBy(value: string | undefined) {
        this._auditCreatedBy = value;
    }
    get status(): string | undefined {
        return this._status;
    }
    set status(value: string | undefined) {
        this._status = value;
    }
    get scanCode(): string | undefined {
        return this._scanCode;
    }
    set scanCode(value: string | undefined) {
        this._scanCode = value;
    }
    get recordId(): string | undefined {
        return this._recordId;
    }
    set recordId(value: string | undefined) {
        this._recordId = value;
    }
    get scanDate(): string | undefined {
        return this._scanDate;
    }
    set scanDate(value: string | undefined) {
        this._scanDate = value;
    }
    get documentId(): string | undefined {
        return this._documentId;
    }
    set documentId(value: string | undefined) {
        this._documentId = value;
    }
    get stackId(): string | undefined {
        return this._stackId;
    }
    set stackId(value: string | undefined) {
        this._stackId = value;
    }
    get type(): string | undefined {
        return this._type;
    }
    set type(value: string | undefined) {
        this._type = value;
    }
    get customerNumber(): string | undefined {
        return this._customerNumber;
    }

    set customerNumber(value: string | undefined) {
        this._customerNumber = value;
    }
    get customer(): CustomerProjectionDto | undefined {
        return this._customer;
    }

    set customer(value: CustomerProjectionDto | undefined) {
        this._customer = value;
    }

    private _id: string | undefined
    private _customerNumber: string | undefined
    private _type: string | undefined
    private _stackId: string | undefined
    private _documentId: string | undefined
    private _scanDate: string | undefined
    private _recordId: string | undefined
    private _scanCode: string | undefined
    private _status: string | undefined
    private _documentNumber: string | undefined
    private _vin: string | undefined
    private _dateOfDeRegistration: string | undefined
    private _dateOfRegistration: string | undefined
    private _licensePlate: string | undefined
    private _receiver: ReceiverDto | undefined
    private _firstDateOfRegistration: string | undefined
    private _customer: CustomerProjectionDto | undefined;
    private _auditCreatedBy: string | undefined
    private _auditCreatedDate: string | undefined
    private _auditLastModifiedBy: string | undefined
    private _auditLastModifiedDate: string | undefined
    private _auditVersion: number = 0
    private _position: number = 0
    private _pageCount: number = 0

    private _loading = false

    constructor() {
        makeAutoObservable(this)
    }

    async load(id: string) {
        this.loading = true
        const result = await catchApi(async () => await api.sea.api.getDocumentScan(id)).catch(() => {
            this.loading = false
        })
        const detail = result?.data;
        const data = detail?.data as DataType
        const audit = detail?.audit

        const {
            customerId,
            customerNumber,
            type,
            stackId,
            documentId,
            scanDate,
            recordId,
            scanCode,
            status,
            number,
            pageCount,
            position,
            vin,
            dateOfDeRegistration,
            dateOfRegistration,
            licensePlate,
            receiver,
            firstDateOfRegistration
        } = data || {}

        if (customerId) {
            await this.loadCustomer(customerNumber).catch(() => {
                this.loading = false
            })
        }

        this.customerNumber = customerNumber
        this.type = type
        this.stackId = stackId
        this.documentId = documentId
        this.scanDate = scanDate
        this.recordId = recordId
        this.scanCode = scanCode
        this.status = status
        this.documentNumber = number
        this.vin = vin
        this.dateOfDeRegistration = dateOfDeRegistration
        this.dateOfRegistration = dateOfRegistration
        this.licensePlate = licensePlate
        this.firstDateOfRegistration = firstDateOfRegistration
        this.receiver = receiver
        this.position = position || 0
        this.pageCount = pageCount || 0

        const {
            createdBy,
            createdDate,
            lastModifiedBy,
            lastModifiedDate,
            version
        } = audit || {}

        this.auditCreatedBy = createdBy
        this.auditCreatedDate = createdDate
        this.auditLastModifiedBy = lastModifiedBy
        this.auditLastModifiedDate = lastModifiedDate
        this.auditVersion = version || 0
        this.id = id
        this.loading = false
    }

    async loadCustomer(id: string) {
        const result = await catchApi(async () => await api.sea.api.findCustomers({query:id}))
        this.customer = result?.data[0]
    }
}

const seaDocumentDetailStore = new SeaDocumentDetailStore()


export {
    seaDocumentDetailStore
}
